import React from 'react';
import { connect } from 'react-redux';
import classes from './Baggage.scss';

import CommonWrapper from '../Common/CommonWrapper/CommonWrapper';
import BaggageSelect from './BaggageSelect/BaggageSelect';
import BaggagePaxSelect from './BaggagePaxSelect/BaggagePaxSelect';
import BaggagePaxSelectMobile from './BaggagePaxSelectMobile/BaggagePaxSelectMobile';
import BaggageNav from './BaggageNav/BaggageNav';

import HeadingH1 from '../../UI/Headings/HeadingH1/HeadingH1';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

import baggageImage from './img/baggage.svg';

import Media from 'react-media';

const baggage = (props) => {
    let baggageKeysOneWay = null;
    let baggageKeysReturn = null;
    if (props.baggage.O) {
        baggageKeysOneWay = Object.keys(props.baggage.O).filter((keyCode) => {
            return props.baggage.O[keyCode].baggageOptions.length !== 0;
        });
    }
    if (props.baggage.R) {
        baggageKeysReturn = Object.keys(props.baggage.R).filter((keyCode) => {
            return props.baggage.R[keyCode].baggageOptions.length !== 0;
        });
    }

    return (
        <React.Fragment>
            <div className={classes.Nav}>
                {
                    baggageKeysOneWay.length > 0 ? <div>
                        <BaggageNav type='depart' baggage={props.baggage.O} baggageView={props.baggageViewO} baggageFlow={props.baggageFlow} flow='O' />
                    </div> : <div>
                        <p className="u-fontSize13 u-textColorNormal u-fontWeightRegular">Baggage selection is not available for departure flight.</p>
                    </div>
                }
                { 
                    props.flightType === "R" ? 
                    props.baggage.R && baggageKeysReturn.length > 0 ? <div style={{ backgroundColor: '#D9DEEC' }}>
                    <BaggageNav type='return' baggage={props.baggage.R} baggageView={props.baggageViewR} baggageFlow={props.baggageFlow} flow='R' />
                    </div> : <div>
                        <p className="u-fontSize13 u-textColorNormal u-fontWeightRegular">Baggage selection is not available for return flight.</p>
                    </div> : null
                }                
            </div>
            <CommonWrapper>
                <div className={classes.BaggageLeft}>
                    <div className={`mb-4`}>
                        <HeadingH3 size={16} weight="Medium" color="Dark">Select Baggage</HeadingH3>
                    </div>
                    <div className={classes.BaggageSelect}>
                        <BaggageSelect baggage={props.baggage} baggageViewO={props.baggageViewO} baggageViewR={props.baggageViewR} flow={props.baggageFlow}/>
                    </div>
                </div>
                <div className={`${classes.BaggageRight} u-phoneHide`}>
                    { (props.selectedBaggage[props.baggageFlow] === {} && props.passengers.length > 1) || props.passengers.length === 1 ? null : <h3 className={`u-fontSize16 u-fontWeightRegular u-textColorDark mb-4`}>Select Passengers</h3> }
                    { 
                        (props.selectedBaggage[props.baggageFlow] === {} && props.passengers.length > 1) || props.passengers.length === 1 ? 
                        <div className={`u-flex align-items-center justify-content-between u-height100Percent`}>
                            <div className={classes.Image}>
                                <div className={`mb-4`}>
                                    <img src={baggageImage} alt='Baggage'/>
                                </div>
                                <div className={`mb-2`}>
                                    <HeadingH1 size={26} weight="Light" color="Dark">Get discount on Baggage!</HeadingH1>
                                </div>
                                <HeadingH3 size={13} weight="Regular" color="Light">Pre-booked baggage are 20% cheaper than on-board price</HeadingH3>
                            </div>
                        </div> : <BaggagePaxSelect amount={props.selectedBaggage[props.baggageFlow][props.baggageFlow === 'O' ? props.baggageViewO : props.baggageViewR].amt} flow={props.baggageFlow} />
                    } 
                </div>
                <Media query="(max-width: 599px)">
                    {matches =>
                        matches && props.selectedBaggage[props.baggageFlow][props.baggageFlow === 'O' ? props.baggageViewO : props.baggageViewR].typ && props.passengers.length > 1 && props.displayPax ? <BaggagePaxSelectMobile flow={props.baggageFlow} /> : null }
                </Media>
            </CommonWrapper>
        </React.Fragment>
    );
}

const mapStateToProps = state => {
    return {
        baggage: state.farePrice.generalData.data.baggage,
        baggageViewO: state.farePrice.baggageViewOneWay,
        baggageViewR: state.farePrice.baggageViewReturn,
        baggageFlow: state.farePrice.baggageFlow,
        passengers: state.farePrice.passengers,
        displayPax: state.farePrice.displayPax,
        selectedBaggage: state.farePrice.selectedBaggage,
        flightType: state.farePrice.flightType
    }
}

export default connect(mapStateToProps)(baggage);


// WEBPACK FOOTER //
// ./src/components/Addons/Baggage/Baggage.js